import { BRAND_FILTER_ID } from '../../containers/orders-filter-bar-container/filter-options/options/seller-brand';
import { TYPE_COLLECTION } from './input-types';

export const id = BRAND_FILTER_ID;
export const apiKey = 'SellerBrandId';
export const type = TYPE_COLLECTION;

export const sellerBrand = {
  id,
  apiKey,
  type,
};
